import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const Trashcan = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("g", {
    clipPath: "url(#clip0_6167_108689)"
  }, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 5.24955H15.6675V4.11705C15.6368 3.37978 15.3097 2.68612 14.7605 2.19334C14.2112 1.70056 13.4863 1.45039 12.75 1.49955H11.4075C9.82227 1.38733 8.44155 2.57081 8.31 4.15455V5.24955H2.25C1.83579 5.24955 1.5 5.58534 1.5 5.99955C1.5 6.41377 1.83579 6.74955 2.25 6.74955H3.4275V18.5846C3.4275 20.7521 4.9275 22.4996 6.75 22.4996H17.19C19.0425 22.4996 20.55 20.7371 20.55 18.5696V6.74955H21.75C22.1642 6.74955 22.5 6.41377 22.5 5.99955C22.5 5.58534 22.1642 5.24955 21.75 5.24955ZM9.81 4.13955C9.81 3.51705 10.56 2.98455 11.4075 2.98455H12.75C13.5975 2.98455 14.19 3.44955 14.19 4.11705V5.24955H9.81V4.13955ZM19.05 18.5846C19.05 19.9271 18.2175 21.0146 17.19 21.0146H6.75C5.73 21.0146 4.8975 19.9271 4.8975 18.5846V6.74955H19.05V18.5846ZM12.75 18.7496H11.25V8.99955H12.75V18.7496ZM9.75 18.7496H8.25V8.99955H9.75V18.7496ZM15.75 18.7496H14.25V8.99955H15.75V18.7496Z",
    fill: "#DC2626"
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "clip0_6167_108689"
  }, __jsx("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
export default Trashcan;